import SyncAccess from './sync-access';
import { cookie } from '@ux/util';
import { get } from './global';

class ShopperData extends SyncAccess {
  get defaults() {
    return {
      info: cookie.get && cookie.get('info_idp') || '{}'
    };
  }

  fetch(done) {
    //
    // This is suppose to be internal data, but we really need shopper information.
    //
    const shopperData = get('window', 'ux.eldorado.shopperData')  || (d => d());

    //
    // Ugly hack but unfortunately the only way to access shopper data atm. Since the data was likely already
    // fetched by the header it should call the callback immediate with data. Obviously this should be possible
    // sync, or this data should be available somewhere. Fire and forget, hope for the best...
    //
    shopperData(done);
  }

  /**
   * Massages the info_idp cookie value into something that looks like the results of ux.eldorado.shopperData
   * @param {string} cookieValue The value of the info_idp cookie (or equivalent)
   * @returns {InitialShopperData} The parsed cookie value
   */
  transform({ info: cookieValue }) {
    try {
      const idpData = JSON.parse(cookieValue);
      const result = { ...idpData, ...(idpData && idpData[idpData.auth]) };
      result.info = cookieValue;
      // fix up the shopperid property to have the right name.
      // Casing here is intentional to match what comes back from shopperData
      if (result.info_shopperId) {
        result.shopperid = result.info_shopperId;
      }
      delete result.info_shopperId;
      return result;
    } catch (e) {
      return { };
    }
  }
}


// Expose just the method
export default (new ShopperData()).data;

// Expose the raw class for testing
export {
  ShopperData
};
